// App locales use underscores (pt_BR); Intl expects BCP 47 tags (pt-BR).
export const toIntlLocale = locale => (locale || 'en').replace('_', '-');

export const formatMoney = (amountCents, currency, locale) =>
  new Intl.NumberFormat(toIntlLocale(locale), {
    style: 'currency',
    currency: currency || 'BRL',
    maximumFractionDigits: 2,
  }).format((amountCents || 0) / 100);

export const formatDate = (isoDate, locale) =>
  new Date(`${isoDate}T00:00:00`).toLocaleDateString(toIntlLocale(locale));

export const sumAmount = deals =>
  deals.reduce((total, deal) => total + (deal.amountCents || 0), 0);

// Editable amount: same thousand/decimal separators the user types (parseAmount reads it back).
export const formatAmountInput = (amountCents, locale) =>
  new Intl.NumberFormat(toIntlLocale(locale), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format((amountCents || 0) / 100);
